import {
  Hammer, Car, Trees, Zap, Flame, Wrench, Sparkles, Scissors, Dumbbell, PaintRoller,
  Ruler, Home, Layers, Grid3x3, KeyRound, Drill, Flower2, Cog, Truck, SprayCan, Dog,
  Smile, Camera, GraduationCap, Briefcase,
} from "lucide-react";

export const CATEGORY_ICONS = {
  "Builder": Hammer,
  "Driving Instructor": Car,
  "Landscaper": Trees,
  "Electrician": Zap,
  "Gas Engineer": Flame,
  "Plumber": Wrench,
  "Cleaner": Sparkles,
  "Hairdresser": Scissors,
  "Personal Trainer": Dumbbell,
  "Painter & Decorator": PaintRoller,
  "Carpenter": Ruler,
  "Roofer": Home,
  "Plasterer": Layers,
  "Tiler": Grid3x3,
  "Locksmith": KeyRound,
  "Handyman": Drill,
  "Gardener": Flower2,
  "Mobile Mechanic": Cog,
  "Removals": Truck,
  "Window Cleaner": SprayCan,
  "Dog Groomer": Dog,
  "Beautician": Smile,
  "Photographer": Camera,
  "Tutor": GraduationCap,
  "Other": Briefcase,
};

const KEYWORD_ICONS = [
  [/artist/i, PaintRoller], [/bathroom/i, Wrench], [/car mechanic/i, Cog], [/^mot/i, Car],
  [/carpet fitter/i, Grid3x3], [/mortgage/i, Home], [/bricklayer/i, Layers],
  [/clean|wash|valet/i, Sparkles], [/hair|barber|groom|tailor|seamstress|dressmak/i, Scissors],
  [/driv|taxi|chauffeur|mot|tyre|auto|windscreen|body shop|vehicle/i, Car], [/mechanic|repair|engineer|appliance/i, Cog],
  [/garden|lawn|tree|pond|landscap/i, Trees], [/electric|solar|ev charger|smart home|alarm|aerial/i, Zap],
  [/gas|heating|boiler|chimney/i, Flame], [/plumb|drain|pool/i, Wrench], [/paint|decorat|wallpaper/i, PaintRoller],
  [/carpent|joiner|kitchen|furniture|upholster|polish/i, Ruler], [/roof|gutter|loft|extension|insulation/i, Home],
  [/tile|floor|carpet|paving/i, Grid3x3], [/build|brick|stone|ground|scaffold|demolition|weld|blacksmith/i, Hammer],
  [/lock|key/i, KeyRound], [/remov|van|courier|delivery|rubbish/i, Truck], [/dog|pet|cat|farrier|equine/i, Dog],
  [/photo|video/i, Camera], [/tutor|teach|instructor|childminder|nanny|coach/i, GraduationCap],
  [/train|fitness|yoga|pilates|massage|physio|osteo|chiro|swim/i, Dumbbell],
  [/beaut|nail|makeup|lash|brow|tan|tattoo|pierc/i, Smile], [/fenc|handy|fitter|install|assembl/i, Drill],
  [/florist|flower/i, Flower2],
];

export const iconFor = (cat) => CATEGORY_ICONS[cat] || KEYWORD_ICONS.find(([rx]) => rx.test(cat || ""))?.[1] || Briefcase;

export const slugify = (s) => s.toLowerCase().replace(/&/g, "and").replace(/[^a-z0-9]+/g, "-");
